import { registerFeatureMessages, type SupportedLocale } from '@/shared/i18n'

export function registerDataExportMessages(locale: SupportedLocale): Promise<void> {
  return registerFeatureMessages('dataExport', locale)
}
